var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-sheet',[_c('div',{staticClass:"mx-auto pa-8"},[_vm._v("\n          "+_vm._s(_vm.$t("greeting"))+"\n          "+_vm._s(this.$store.state.user.profile.first_name)+"\n        ")])])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":4,"sm":6,"lg":4}},[_c('last-feedbacks')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }